// extracted by mini-css-extract-plugin
module.exports = {"dl-wrapper":"PartnerBox_dl-wrapper__HCFYf","h2":"PartnerBox_h2__uCQoM","imagesWrapper":"PartnerBox_imagesWrapper__BRLmp"};